import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import ImageCropper from "@/components/VisualSearch/v1/ResultPage/ImageCropper"
import ProductDetail from "@/components/VisualSearch/v1/ResultPage/ProductDetail"
import Style from "@/components/VisualSearch/v1/ResultPage/index.module.scss"
import Button from "@/components/core/Button/Button"
import { getTranslations } from "@/components/VisualSearch/localization"
import { useTranslation } from "next-i18next"
import { getProductByImage } from "@/services/ct.service"
import {
  getValidCategory,
  getDetailSku,
  getServiceParts,
  getScrollTo,
} from "@/components/VisualSearch/v1/utils"
import { getPartList } from "@/store/features/pdpSlice"
import { useDispatch } from "react-redux"
import PartsViewerV2 from "@/components/PartsViewer/v2/PartsViewer"
import ResultLoading from "@/components/VisualSearch/v1/ResultPage/LoadingPage"
import ListLoading from "@/components/VisualSearch/v1/ResultPage/ProductDtls/LoadingPage"
import ProductCards from "@/components/VisualSearch/v1/ResultPage/ProductCards"
import { showMedalliaFeedbackModal } from "@/services/medallia"

const ResultPage = props => {
  const {
    image,
    productResult,
    setSection,
    setOutput,
    output,
    setProductResult,
    category,
    loading,
    setLoading,
  } = props
  const categoryVal = getValidCategory(category)
  const toiletGroup = categoryVal === "toilet_group" ? true : false
  const [groupFlagValue, setGroupFlagValue] = useState(toiletGroup)
  const [partsFlag, setPartsFlag] = useState(true)
  const [partsLoading, setPartsLoading] = useState(false)

  const topFiveResults = productResult?.topResults || []
  const groupList = productResult?.listResults || []

  let prodResult = toiletGroup ? groupList : topFiveResults
  if (Array.isArray(prodResult) && prodResult.length > 8) {
    prodResult = prodResult.slice(0, 8)
  }
  const skuResultList = toiletGroup
    ? groupList
    : topFiveResults.filter(item => item?.sku !== productResult?.sku)
  const skuLists = skuResultList?.map(item => item.sku)
  const productLists = prodResult?.map(item => item.productNo)
  const [productId, setProductId] = useState(null)
  const productDtlId = groupFlagValue ? null : productResult?.productNo

  const { t } = useTranslation()
  const { helpText, feedbackText } = getTranslations(t)
  const dispatch = useDispatch()
  const [show, setShow] = useState(false)
  const [productInfo, setProductInfo] = useState({})

  const getSkufromApi = async () => {
    const { file } = image
    setLoading(false)
    try {
      if (output?.predictionData) {
        const coordinates = output?.predictionData
        const formdata = new FormData()
        formdata.append("category", categoryVal)
        formdata.append("file", file)
        if (coordinates) {
          formdata.append("coordinates", JSON.stringify(coordinates))
        }
        const response = await getProductByImage(formdata)
        if (response?.data?.result) {
          const slug = response?.data?.result?.slug
          const skuId = response?.data?.result?.sku
          const resp = await getDetailSku(slug, skuId)
          const mergedResponse = {
            ...response?.data?.result,
            allswatch: [resp],
          }
          setLoading(true)
          setProductResult(mergedResponse)
        } else {
          console.log("Error in fetching SKU API")
          setSection("error")
        }
      }
    } catch (err) {
      console.log(err, "Error in fetching SKU API")
    }
  }
  const [productInfoMap, setProductInfoMap] = useState({})
  const fetchAllProductInfo = async () => {
    const newProductInfoMap = {}
    for (const id of productLists) {
      const productInfo = await getProductInfo(id)
      newProductInfoMap[id] = { ...productInfo }
    }

    setProductInfoMap(newProductInfoMap)
  }

  useEffect(() => {
    setProductInfo({})
    setPartsLoading(false)
    fetchAllProductInfo()
    setPartsLoading(true)
  }, [productResult])

  useEffect(() => {
    try {
      setProductInfo({})
      if (output?.predictionData) {
        setPartsLoading(false)
        if (toiletGroup) {
          setGroupFlagValue(true)
        }
        getSkufromApi()
        setPartsLoading(true)
      }
    } catch (err) {
      console.log(err, "Error in fetching predictionData SKU API")
    }
  }, [output?.predictionData])

  useEffect(() => {
    if (show) {
      if (productInfoMap[productDtlId])
        setProductInfo({ ...productInfoMap[productInfoMap[productDtlId]] })
      else if (productInfoMap[productId]) {
        setProductInfo({ ...productInfoMap[productId] })
      }
    } else if (show === false) {
      setProductId(null)
      getScrollTo("Collapsible")
    } else {
      setProductId(null)
    }
  }, [show])

  const getProductInfo = async productId => {
    try {
      const partList = await dispatch(getPartList({ productId })).unwrap()
      const parts = getServiceParts(partList)
      return parts
    } catch (e) {
      console.log(e, "Error in Rendering Parts nad Diagram")
    }
  }

  useEffect(() => {
    getScrollTo("Collapsible")
  }, [])

  return (
    <div className={`${Style.ResultWrapper}`}>
      <div className="product-result-layout w-100 h-100 top-0 container p-0 d-flex flex-column justify-content-between">
        <div className="container-wrapper w-100">
          <div className="px-0 px-container flex-column">
            <div className="products-splits-containers w-100 ">
              <ImageCropper
                image={image}
                product={productResult}
                setSection={setSection}
                setOutput={setOutput}
                output={output}
                loading={loading}
                groupFlagValue={groupFlagValue}
              />

              {(!loading || !partsLoading) &&
                (groupFlagValue ? (
                  <ResultLoading skuLists={skuLists} />
                ) : (
                  <div className="d-flex justify-content-between align-items-center flex-column w-100">
                    <ListLoading />
                    <ResultLoading skuLists={skuLists} />
                  </div>
                ))}

              {loading && partsLoading && (
                <>
                  {groupFlagValue ? (
                    <div className="container result-items match-container ">
                      <ProductCards
                        skuLists={skuLists}
                        prodResult={prodResult}
                        setProductId={setProductId}
                        setPartsFlag={setPartsFlag}
                        setShow={setShow}
                        groupFlagValue={groupFlagValue}
                      />
                    </div>
                  ) : (
                    <div className="container match-container">
                      <ProductDetail
                        product={productResult}
                        loading={loading}
                        show={show}
                        setShow={setShow}
                        setProductInfo={setProductInfo}
                        productInfo={productInfo}
                        productIds={productDtlId}
                        setPartsFlag={setPartsFlag}
                        partsFlag={partsFlag}
                      />
                      <div className=" result-items ">
                        <ProductCards
                          skuLists={skuLists}
                          prodResult={prodResult}
                          setPartsFlag={setPartsFlag}
                          setShow={setShow}
                          setProductId={setProductId}
                        />
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>

          {show ? (
            <PartsViewerV2
              onClose={() => setShow(false)}
              productId={productId ?? productDtlId}
              partId={
                productInfoMap?.[productId]?.partId ??
                productInfoMap?.[productDtlId]?.partId
              }
              showModal={show}
              page="visual search"
              fileMap={
                productInfoMap?.[productId]?.fileMap ??
                productInfoMap?.[productDtlId]?.fileMap
              }
            />
          ) : null}
        </div>
      </div>
      <div className="feedback-wrapper">
        <div className=" provide-feedback visualContentwarppers">
          <div className="feedback">
            <p>{helpText}</p>
            <Button
              className="provide-feedback-button"
              type="ghost"
              label={feedbackText}
              size="large"
              flexible={true}
              role="button"
              onClick={showMedalliaFeedbackModal}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
ResultPage.propTypes = {
  image: PropTypes.object.isRequired,
  productResult: PropTypes.object,
  setSection: PropTypes.func.isRequired,
  setOutput: PropTypes.func.isRequired,
  output: PropTypes.object,
  setProductResult: PropTypes.func.isRequired,
  category: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  setLoading: PropTypes.func.isRequired,
}

export default ResultPage
